/**
 * Created by Angelika on 05.09.2017.
 */
import React, {Component} from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import PropTypes from "prop-types";
import {browserHistory} from 'react-router';
import 'video.js/dist/video-js.min.css';
import 'videojs-contrib-hls';
import * as VideoActions from "../actions/video";
import * as formats from '../constants/formats';
import * as errors from '../constants/errors';
import * as strings from '../constants/strings';
import * as def from '../constants/defines';
import * as videoErrors from '../constants/videoErrors';
import Dialog from '../components/Dialog';
import videojs from 'video.js';

class VideoBlock extends Component {

    constructor(props) {
        super(props);
        this.player = null;
        this.activeTimeout = null;
        this.state = {
            active: false
        };

        this.handleVolumeChange = this.handleVolumeChange.bind(this);
    }

    componentDidMount() {
        const {videoActions, channelLink: {url, format}} = this.props;
        switch (format) {
            case formats.MP4:
                this.videoNode.src = url;
                this.doPlay();
                break;

            case formats.HLS:
                this.loadHLSVideo();
                break;

            case formats.UNDEFINED_FORMAT:
                videoActions.setError(strings.VIDEO_ERROR_POPUP_TITLE_FORMAT, errors.VIDEO_FORMAT_UNDEFINED);
                break;

            default:
                break;
        }
        document.addEventListener("fullscreenchange", this.fullScreenChange.bind(this), false);
        document.addEventListener("webkitfullscreenchange", this.fullScreenChange.bind(this), false);
        document.addEventListener("mozfullscreenchange", this.fullScreenChange.bind(this), false);
    }

    componentWillUnmount() {
        if (this.player) {
            this.player.dispose();
        }
        if (this.activeTimeout) {
            clearTimeout(this.activeTimeout);
        }
        document.removeEventListener("fullscreenchange", this.fullScreenChange.bind(this));
        document.removeEventListener("webkitfullscreenchange", this.fullScreenChange.bind(this));
        document.removeEventListener("mozfullscreenchange", this.fullScreenChange.bind(this));
    }

    componentWillReceiveProps(nextProps) {
        const {video} = nextProps;
        if (video.paused !== this.props.video.paused) {
            if (video.paused && !this.videoNode.paused) {
                this.videoNode.pause();
            }
            if (!video.paused && this.videoNode.paused) {
                this.videoNode.play();
            }
            this.videoNode.volume = video.volume;
        }
    }

    goBack() {
        setTimeout(() => browserHistory.push('/channels'), def.RETURN_TIMEOUT);
    }

    loadHLSVideo() {
        let self = this;
        const {video, channelLink: {url}, preview} = this.props;
        const options = {
            hls: {
                withCredentials: true,
                overrideNative: true
            }
        };
        // const src = "http://d2zihajmogu5jn.cloudfront.net/bipbop-advanced/bipbop_16x9_variant.m3u8";
        // const src = "https://d1si4392ltqpn6.cloudfront.net/coco-trailer-2_h1080p/encoded-21-31-06-wed-sep-2017/encoded-21-31-06-wed-sep-2017.m3u8";
        try {
            this.player = videojs(this.videoNode, options, () => {
                videojs.log('onPlayerReady', this);
            });

            this.player.src({
                src: url,
                // src: src,
                type: 'application/x-mpegURL'
            });
            if (!preview) {
                this.player.loadingSpinner.hide();
            }

            this.player.on('loadedmetadata', function () {
                self.initHlsLevels();
            });

            this.player.on('ready', function () {
                this.addClass('wrapper');
                if (!video.paused) {
                    self.doPlay();
                }
            });

            this.player.on('error', function (err) {
                self.onHlsError(this.error_.code);
            });

        } catch (error) {
            console.log('loadHLSVideo error happened: ' + error);
        }
    }

    onHlsError(code) {
        const {videoActions} = this.props;
        videoActions.pause();
        let error_description = null;
        switch (code) {
            case videoErrors.MEDIA_ERR_ABORTED:
                error_description = errors.MEDIA_ERR_ABORTED;
                break;

            case videoErrors.MEDIA_ERR_NETWORK:
                error_description = errors.MEDIA_ERR_NETWORK;
                break;

            case videoErrors.MEDIA_ERR_DECODE:
                error_description = errors.MEDIA_ERR_DECODE;
                break;

            case videoErrors.MEDIA_ERR_SRC_NOT_SUPPORTED:
                error_description = errors.MEDIA_ERR_SRC_NOT_SUPPORTED;
                break;

            case videoErrors.MEDIA_ERR_ENCRYPTED:
                error_description = errors.MEDIA_ERR_ENCRYPTED;
                break;

            default:
                break;
        }

        videoActions.setError(strings.VIDEO_ERROR_POPUP_TITLE_HLS, error_description);
    }

    printLevel(level) {
        return `${level.width}p`;
    }

    doPlay() {
        const {videoActions} = this.props;
        videoActions.play();
        if (this.player) {
            this.player.play();
        }
    }

    initHlsLevels() {
        const {videoActions} = this.props;
        try {
            let qualityLevels = this.player.tech_.hls.representations();
            videoActions.setHlsLevels(qualityLevels);
            qualityLevels.forEach(function (rep) {
                if (rep.enabled()) {
                    videoActions.setHlsCurrentLevel(rep.width);
                }
            });
        } catch (error) {
            console.log('initHlsLevels error happened: ' + error);
        }
    }

    changeCurrentLevel(level) {
        const {videoActions} = this.props;
        this.player.tech_.hls.representations().forEach(function (rep) {
            if (rep.width === level) {
                rep.enabled(true);
            } else {
                rep.enabled(false);
            }
        });
        videoActions.setHlsCurrentLevel(+level);
    }

    toggleFullScreen() {
        const {video} = this.props;
        let element = document.getElementById('player');
        if (!video.expanded) {
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.webkitRequestFullscreen) {
                element.webkitRequestFullscreen();
            } else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
            } else if (element.msRequestFullscreen) {
                element.msRequestFullscreen();
            }
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        }
    }

    fullScreenChange() {
        const {videoActions} = this.props;
        let fullscreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
        if (fullscreenElement) {
            videoActions.expand();
        } else {
            videoActions.collapse();
        }
    }

    goToPlayerFrame() {
        const {activeChannel} = this.props;
        browserHistory.push(`/channels/${activeChannel.channelID}`);
    }

    activateControls() {
        if (!this.state.active) {
            this.setState({active: true}, () => {
                this.activeTimeout = setTimeout(() => this.setState({active: false}), def.VIDEO_DISACTIVATE_CONTROLS);
            });
        }
    }

    setVolume(value) {
        this.videoNode.volume = value;
    }

    handleVolumeChange(event) {
        let {value} = event.target;

        this.props.videoActions.changeVolume(value);
        this.setVolume(value);
    }

    render() {
        const {video, videoActions, preview} = this.props;
        const {hlsLevels, hlsCurrentLevel} = video;
        return (
            <div id="player" className={video.classes + (this.state.active ? " active" : "")} onMouseDown={this.activateControls.bind(this)} onMouseMove={this.activateControls.bind(this)}>
                <video ref={node => this.videoNode = node} muted={video.muted}
                       onDoubleClick={preview ? this.goToPlayerFrame.bind(this) : this.toggleFullScreen.bind(this)}>
                </video>
                {video.hasError &&
                <Dialog title={video.error_title} description={video.error_description}
                        labelOK={strings.STR_PLAYER_BACK}
                        labelCancel={strings.STR_PLAYER_CONTINUE} onOK={this.goBack.bind(this)}/>
                }
                {video.paused && !video.hasError &&
                <div id="big-play-button" onClick={this.doPlay.bind(this)}>&nbsp;</div>
                }
                {!video.hasError &&
                <div className="controls-block">
                    <div className="controls">
                        <div className="wrapper">
                            {video.paused && <div className="control-item play" onClick={() => videoActions.play()}>&nbsp;</div>}
                            {!video.paused && <div className="control-item pause" onClick={() => videoActions.pause()}>&nbsp;</div>}
                            {!preview && <div className="control-item levels">
                                {hlsLevels && hlsLevels.length > 0 &&
                                <select //disabled={hlsLevels.length===1 ? "disabled" : ""}
                                    value={hlsCurrentLevel != null ? hlsCurrentLevel : ''}
                                    onChange={e => this.changeCurrentLevel(e.target.value)}>
                                    {hlsLevels.map((level, index) => (
                                        <option key={index} value={level.width}>{this.printLevel(level)}</option>
                                    ))}
                                </select>}
                            </div>}
                            <div className="right">
                                <div className={"control-item volume-control " + (video.muted ? "muted" : "unmuted")}
                                     onClick={() => videoActions.mute()}></div>
                                <div className="control-item volume">
                                    <input type="range" min="0" max="1" step="0.1" value={video.volume}
                                           onChange={(event) => this.handleVolumeChange(event)}/>
                                </div>
                                <div className="control-item full-screen"
                                     onClick={this.toggleFullScreen.bind(this)}>&nbsp;</div>
                            </div>
                        </div>
                    </div>
                </div>
                }
            </div>
        )
    }
}

VideoBlock.propTypes = {
    video: PropTypes.shape({
        paused: PropTypes.bool,
        stopped: PropTypes.bool,
        muted: PropTypes.bool,
        volume: PropTypes.number,
        quality: PropTypes.number,
        hasError: PropTypes.bool.isRequired,
        hlsLevels: PropTypes.array,
        hlsCurrentLevel: PropTypes.number
    }).isRequired,
    channelLink: PropTypes.shape({
        format: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired
    }),
    stopVideo: PropTypes.func,
    preview: PropTypes.bool.isRequired
};

const mapStateToProps = state => {
    return {
        video: state.video,
        activeChannel: state.channels.activeChannel,
        channelLink: state.channelLink
    }
};

const mapDispatchToProps = dispatch => {
    return {
        videoActions: bindActionCreators(VideoActions, dispatch)
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VideoBlock);


// WEBPACK FOOTER //
// ./src/containers/VideoBlock.js